99<template>

    <v-row class="d-flex justify-space-between mb-2 mt-2">
      <v-col cols="12" md="3" v-if="props.isClubManager" >
        <v-btn color="success" @click="showRegistration = true">Přidat reprezentanta</v-btn>
      </v-col>
      <v-col cols="12" md="2" v-if="props.isClubManager">
        <v-btn color="primary" @click="copyEmails">Zkopírovat emaily</v-btn>
      </v-col>
      <v-col cols="12" md="2" v-if="props.isClubManager && props.hasClubManagerData">
        <v-btn color="primary" @click="submitChanges">Uložit pravomoce</v-btn>
      </v-col>
    </v-row>

    <v-alert type="error" v-if="deleteErrorMessage" class="my-2">{{ deleteErrorMessage }}</v-alert>

    <!-- Dialog egistrace člena -->
    <v-dialog v-model="showRegistration" max-width="900px">
      <v-card>
        <ClubPageRepreReistration
          :club="props.club"
          @registered="onRegistered"
          @close="showRegistration = false"
        />
      </v-card> 
    </v-dialog>



    <div v-for="group in groupedMembers" :key="group.lvl">
      <h2 class="mt-6 mb-2">{{ lvlLabels[group.lvl] }}</h2>

      <v-data-table
        :headers="memberHeaders"
        :items="group.items"
        density="compact"
        :items-per-page="-1"
        hide-default-footer
        :loading="loading"
        loading-text="Načítám data..."
        width="100%"
        no-data-text="Žádní reprezentanti v této skupině zařazeni nejsou"
        :sort-by="sortBy"

      >
        <template v-slot:[`item.last_name`]="{ item }">
          <v-tooltip
            location="top center"
            origin="auto"
            :text="'Poslední aktivita: ' + $formatDateTime(item.last_activity)"
          >
            <template #activator="{ props }">
              <router-link
                v-bind="props"
                :to="`/ucet/${item.id}`"
                style="white-space: nowrap;"
              >
                {{ item.last_name }} {{ item.first_name }}
              </router-link>
            </template>
          </v-tooltip>
        </template>

        <template v-if="isClubManager" v-slot:[`item.email`]="{ item }">
          {{ item.email }}
        </template>
        <template v-if="isClubManager" v-slot:[`item.si_number`]="{ item }">
          {{ item.si_number }}
        </template>

        <template v-if="group.lvl === ''" v-slot:[`item.description`]="{ item }">
          {{ item.description }}
        </template>
        <!-- <template v-else v-slot:[`item.description`]="{ item }">
        </template> -->
        <template v-if="isClubManager && hasOrganizerData" 
          v-slot:[`item.organizer`]="{ item }">
          <v-checkbox density="compact" v-model="item.is_organizer" hide-details></v-checkbox>
        </template>

        <template
          v-if="isClubManager && hasClubManagerData"
          v-slot:[`item.club_manager`]="{ item }"
        >
          <v-checkbox
            v-model="item.is_club_manager"
            :disabled="item.id === Number(authStore.userID)"
            density="compact"
            hide-details
          />
        </template>

        <template
          v-if="isClubManager && hasClubManagerData"
          v-slot:[`item.actions`]="{ item }"
        >
          <v-list-item-action>
            <v-icon
              @click="openEditDialog(item)"
              color="blue"
              size="x-large"
              class="mr-2"
              title="editovat údaje člena"
            >mdi-pencil</v-icon>
            <v-icon
              @click="openRemoveDialog(item)"
              v-if="item.id !== Number(authStore.userID)"
              color="warning"
              size="x-large"
              class="mr-2"
              title="zrušit členství v oddíle"
            >mdi-account-remove</v-icon>
          </v-list-item-action>
        </template>

      </v-data-table>
    </div>


    <!-- Dialog pro editaci Account -->
    <v-dialog v-model="dialogEditAccount" persistent max-width="600px">
    <v-card>
        <v-card-title>
            {{ selectedAccount.last_name }} {{ selectedAccount.first_name }} ({{ selectedAccount.index }})
        </v-card-title>
        <v-card-text>

            <v-row>
            <v-col cols="12">
                <v-select v-model="selectedAccount.lvl" :items="lvlOptions" label="Kádr" :rules="[rules.lvl]" density="comfortable" />
            </v-col>
            <!-- <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.last_name" label="Příjmení" required :rules="[rules.last_name]"></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.first_name" label="Křestní jméno" required :rules="[rules.firstName]"></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
                <CountrySelect v-model="selectedAccount.country" label="Země" />
            </v-col>
            <v-col cols="12" md="5">
                <v-text-field v-model="selectedAccount.email" label="Email" :rules="[rules.isValidEmail]" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-text-field v-model="selectedAccount.si_number" type="number" label="Číslo čipu" :rules="[rules.siNumber]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-autocomplete
                v-model="selectedAccount.assist_user"
                :items="assistUser"
                label="Správce tohoto účtu"
                item-value="id"
                item-title="fullName"
                clearable
                no-data-text="Uživatel není v databázi"
                ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="selectedAccount.birth_year" label="Rok narození" type="number" :rules="[rules.year]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-select v-model="selectedAccount.gender" :items="sexOptions" label="Pohlaví" :rules="[rules.gender]"></v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field v-model="selectedAccount.index" label="Index" required :rules="[rules.index]"></v-text-field>
            </v-col> -->
            </v-row>

            <v-alert type="error" v-if="errorMessage">{{ errorMessage }}</v-alert>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogEditAccount = false">Zrušit</v-btn>
            <v-btn color="green darken-1" text @click="editAccount" :disabled="!isFormValid">Uložit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>



    <!-- Dialog pro potvrzení smazání člena oddílu -->
    <v-dialog v-model="dialogRemoveAccount" persistent max-width="600px">
        <v-card>
            <v-card-title class="text-h5">Potvrzení odebrání člena</v-card-title>
            <v-card-text>Opravdu chceš odebrat člena <b>{{ selectedAccount.last_name }} {{ selectedAccount.first_name }}</b> z oddílu? Závodníkovi se tak ukončí členství v oddíle.</v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogRemoveAccount = false">Zrušit</v-btn>
            <v-btn color="warning darken-1" text @click="removeAccount">Odebrat člena</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>




  <ScrollTopButton />

</template>


<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import apiClient from '/api.js';
import { useAuthStore } from '/auth.js';

import ScrollTopButton from '@/components/shared/ScrollTopButton.vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import ClubPageRepreReistration from './ClubPageMembersTableRepreReistration.vue';

const snackbar = useSnackbarStore()
const authStore = useAuthStore();

const props = defineProps({
    members: Array,
    club: Object,
    assistUser: Array,
    isClubManager: Boolean,
    hasOrganizerData: Boolean,
    hasClubManagerData: Boolean,    
    loading: Boolean,
  });


const emit = defineEmits(['fetchMembers']);

// const { isLoggedIn } = storeToRefs(useAuthStore());
const route = useRoute();
const clubShortcut = ref(route.params.id); // Získání ID oddílu z URL

const errorMessage = ref('');
const deleteErrorMessage = ref('');


const lvlOptions = [
  { title: 'Užší',     value: '1' },
  { title: 'Širší',     value: '2' },
  { title: 'Sledovaní', value: '3' },
  { title: 'Realizační tým', value: '' },
]

// pevné pořadí a popisky "kádru"
const lvlBuckets = ['1', '2', '3', '']
const lvlLabels = {
  '1': 'Užší kádr',
  '2': 'Širší kádr',
  '3': 'Sledovaní',
  '':  'Realizační tým'
}

// rozdělíme členy do skupin podle lvl
const groupedMembers = computed(() => {
  return lvlBuckets.map(l => ({
    lvl: l,
    label: lvlLabels[l],
    // u realizačního týmu můžete později číst i item.description
    items: props.members.filter(m => m.lvl === l)
  }))
})

const sortBy = [{ key: 'birth_year', order: 'asc' }]; // Klíč pro řazení

// společné hlavičky pro všechny tabulky, podle oprávnění
const memberHeaders = computed(() => {
  const headers = [
    { title: 'Jméno',      value: 'last_name', sortable: true, align: 'start' },
    { title: 'Index',      value: 'index',     sortable: true, align: 'start' },
  ];

  if (props.isClubManager) {
    headers.push(
      { title: 'Email',         value: 'email',      sortable: false },
      { title: 'Číslo čipu',    value: 'si_number',  sortable: false },
      { title: 'Rok narození',  value: 'birth_year', sortable: true, align: 'start' },
    );
  }

  if (props.isClubManager && props.hasClubManagerData) {
    headers.push(
      { title: 'Organizátor', value: 'organizer', sortable: false },
      { title: 'Správce reprezentace', value: 'club_manager', sortable: false },
      { title: 'Akce',           value: 'actions',      sortable: false, width: '120' },
    );
  }

  // description sloupec vždy – data uvidíte jen v realizačním týmu
  // headers.push({ title: 'Popis', value: 'description', sortable: false });

  return headers;
});

// Aktualizace seznamu členů po registraci nového
const showRegistration = ref(false); // Zobrazit dialog pro registraci člena

function onRegistered() {
  showRegistration.value = false;
  // obnov seznam členů
  emit('fetchMembers');
}

const dialogEditAccount = ref(false);
const openEditDialog = (account) => {
  selectedAccount.value = { ...account }
  dialogEditAccount.value = true;
};

const selectedAccount = ref({
  last_name: '',
  first_name: '',
  email: '',
  si_number: null,
  birth_year: null,
  gender: '',
  index: '',
  assist_user: null,
  country: '',
  lvl: '',
});

const dialogRemoveAccount = ref(false);
const openRemoveDialog = (account) => {
  selectedAccount.value = account;
  dialogRemoveAccount.value = true;
};




const rules = {
  
  // isValidEmail: value => (/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) || 'Neplatný email',
  // year: value => (value && value >= 1920 && value <= new Date().getFullYear()) || 'Neplatný rok.',
  // siNumber: value => !value || /^\d{4,7}$/.test(value) || 'Číslo SI musí mít 4 až 7 cifer.',
  // index: value => (/^[A-Za-z]{3}\d{4}$/.test(value)) || 'Neplatný index',
  // firstName: value => (value.trim() !== '') || 'Jméno je povinné pole.',
  // last_name: value => (value.trim() !== '') || 'Příjmení je povinné pole.',
  // gender: value => (['M', 'F'].includes(value)) || 'Pohlaví je povinné pole.',
  lvl: v => ['1','2','3',''].includes(v) || 'Vyber kádr.',


};

// validace pro disable tlačítka uložit v edit account
const isFormValid = computed(() => {
  return rules.lvl(selectedAccount.value.lvl) === true;
    // rules.isValidEmail(selectedAccount.value.email) === true &&
    // rules.year(selectedAccount.value.birth_year) === true &&
    // rules.siNumber(selectedAccount.value.si_number) === true &&
    // rules.index(selectedAccount.value.index) === true &&
    // rules.firstName(selectedAccount.value.first_name) === true &&
    // rules.last_name(selectedAccount.value.last_name) === true &&
    // rules.gender(selectedAccount.value.gender) === true;
});






const copyEmails = async () => {
   // Filtrování členů, kteří mají email a neobsahují "rob-is.cz"
   const emails = props.members
    .filter(member => member.email && !member.email.includes('rob-is.cz'))  // Filtrovat jen členy, kteří mají email a email neobsahuje "rob-is.cz"
    .map(member => member.email)     // Získat emaily
    .join(', ');                     // Spojit emaily do jednoho řetězce odděleného čárkou

  try {
    // Zkopírování emailů do schránky
    await navigator.clipboard.writeText(emails);
    snackbar.showSnackbar('Emaily byly zkopírovány.');
  } catch (err) {
    console.error('Chyba při kopírování emailů:', err);
  }
};


const submitChanges = async () => {
  // Tvorba seznamu aktualizovaných členů pro odeslání
   const updatedMembers = props.members.map(member => ({
    role_id: member.role_id,
    is_organizer: !!member.is_organizer,
    is_club_manager: !!member.is_club_manager
  }));

  // Kontrolní log výsledného seznamu pro ověření
  console.log('Updating member roles:', JSON.stringify(updatedMembers));

  // Odesílání dat na server
  try {
    const response = await apiClient.post(`members/?club_shortcut=${clubShortcut.value}`, updatedMembers);
    if (response.status === 200) {
      snackbar.showSnackbar('Pravomoce byly úspěšně aktualizovány.');
      authStore.updateRoles(response.data.user_permissions); // uložení rolí uživatele do pinia auth sotre
      emit("fetchMembers");
    } else {
      throw new Error('Failed to update member roles');
    }
  } catch (error) {
    console.error('Error updating member roles:', error);
  }
};



const editAccount = async () => {
  try {
    // Vytvoření jednoduchého objektu z reaktivního selectedAccount
    const accountData = {
      id: selectedAccount.value.id,
      // first_name: selectedAccount.value.first_name,
      // last_name: selectedAccount.value.last_name,
      // email: selectedAccount.value.email,
      // si_number: selectedAccount.value.si_number,
      // birth_year: selectedAccount.value.birth_year,
      // gender: selectedAccount.value.gender,
      // index: selectedAccount.value.index,
      // assist_user: selectedAccount.value.assist_user,
      // country: selectedAccount.value.country,
      lvl: selectedAccount.value.lvl,
    };
    if (accountData.lvl === '0') {
      accountData.lvl = ''; // Pokud je úroveň 0, nastavíme ji na prázdnou hodnotu
    }
    
    const response = await apiClient.put(`/members/?role_id=${selectedAccount.value.role_id}`, accountData);
    if (response.status === 200) {
      snackbar.showSnackbar('Údaje byly úspěšně aktualizovány.');
      emit("fetchMembers"); // Aktualizace seznamu členů po úspěšném uložení
      dialogEditAccount.value = false;
      errorMessage.value = ""
      }
    } catch (error) {
    if (error.response && error.response.status === 409) {
      errorMessage.value = error.response.data.error;
    } else {
      errorMessage.value = 'Údaje se nepodařilo uložit: ' + error.message;
    }
    console.error('Error updating account:', error);
  }
};



const removeAccount = async () => {
  try {
    const response = await apiClient.post(`members/?remove_index=${selectedAccount.value.index}`);
    if (response.status === 200) {
      snackbar.showSnackbar('Účet byl úspěšně vyřazen z reprezentace');
      emit("fetchMembers"); // Obnovit seznam členů po úspěšném vyřazení
    } else {
      throw new Error('Failed to delete account');
    }
  } catch (error) {
    console.error('Error deleting account:', error);
  } finally {
    dialogRemoveAccount.value = false;
  }
};





</script>

<style scoped>



</style>
